import React, { useEffect, useState } from "react"
import AddIcon from "@mui/icons-material/Add"
import { Link } from "react-router-dom"
import CachedIcon from "@mui/icons-material/Cached"
import SearchIcon from "@mui/icons-material/Search"
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks"
import { useGlobalContext } from "../../../Context/GlobalContext"
import BorderColorIcon from "@mui/icons-material/BorderColor"
import DeleteIcon from "@mui/icons-material/Delete"
import Select from "react-select"
import { saveAs } from "file-saver"
import jsPDF from "jspdf"
import ClipLoader from "react-spinners/ClipLoader"
import "react-responsive-modal/styles.css"
import { Modal } from "react-responsive-modal"
import { IoMdArrowDropright } from "react-icons/io"
import ClientsEditModal from "../../../components/Staff/Modals/ClientsEditModal"
import Cookies from "js-cookie"
import Skeleton from "react-loading-skeleton"

const Clients = () => {
  const [openClientsEditModal, setOpenClientsEditModal] = useState(false)
  const {
    fetchDetail,
    isOpen,
    setIsOpen,
    fetchClientDetail,
    clientDetail,
    totalRecord,
    setClientDetail,
    isLoading,
    setIsLoading,
    loadingClient,
    baseUrl,
    openToast,
  } = useGlobalContext()
  useEffect(() => {
    console.log(openClientsEditModal)
  }, [openClientsEditModal])

  const [isOn3, setIsOn3] = useState(false)
  const [open8, setOpen8] = useState(false)

  const onOpenModal8 = () => setOpen8(true)
  const onCloseModal8 = () => setOpen8(false)

  const [departments, setDepartments] = useState([])
  const [companyName, setCompanyName] = useState("")
  const [searchedClients, setSearchClients] = useState(null)
  const [rowsToShow, setRowsToShow] = useState(25)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [name, setName] = useState("")
  const [isDownloading, setIsDownloading] = useState(false)
  const [loading, setLoading] = useState(false)

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F5F9",
      borderColor: "#E2E8F0",
      minHeight: "38px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#E2E8F0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "14px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#4A5568",
      ":hover": {
        backgroundColor: "#CBD5E0",
        color: "#2D3748",
      },
    }),
  }

  const [isOpen15, setIsOpen15] = useState(false)

  const [divs, setDivs] = useState([{}]) // Start with one empty object

  const [openIndex, setOpenIndex] = useState(0)
  let subtitle
  // Function to handle accordion toggling
  const handleToggle = (index) => {
    if (openIndex === index) {
      setOpenIndex(null) // Close the accordion if clicked again
    } else {
      setOpenIndex(index) // Open the accordion
    }
  }
  //salary dropdown
  const [isOpen1, setIsOpen1] = useState(false)

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1)
  }

  //salary dropdown

  //Toggle swich off on btn
  const [isOn, setIsOn] = useState(false)

  //Toggle swich off on btn

  //Toggle swich off on btn
  const [isOn1, setIsOn1] = useState(false)

  const toggleSwitch1 = () => {
    setIsOn1(!isOn1)
  }

  //

  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value))
  }

  const [exportFormat, setExportFormat] = useState("CSV")

  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV()
    else if (exportFormat === "PDF") exportPDF()
    else if (exportFormat === "Print") printContent()
  }

  const fetchData = async () => {
    const result = await fetch(`${baseUrl}/client?limit=${rowsToShow}`, {
      headers: {
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
    })
    const data = await result.json()
    return data.data
  }
  const exportCSV = async () => {
    setIsDownloading(true)
    try {
      const headers = [
        "Name",
        "Company",
        "Primary Contact",
        "Primary Email",
        "Phone",
        "Groups",
        "Currency",
        "Default Language",
        "Address",
        "Country",
        "State",
        "City",
        "Zip Code",
        "Date Created",
      ]

      const d = await fetchData()
      const csvData = [
        headers.join(","), // Add headers
        ...d.map((client) => {
          const groups = client?.clientDetails?.groups?.join(";")
          const currency = client?.clientDetails?.currency?.join(";")
          const default_language = client?.clientDetails?.default_language?.join(";")

          // Ensure that each value is properly quoted to handle commas or special characters
          return [
            `"${client?.name ?? "N/A"}"`,
            `"${client?.clientDetails?.company || "N/A"}"`,
            `"${client?.phone ?? "N/A"}"`,
            `"${client?.email ?? "N/A"}"`,
            `"${groups ?? "N/A"}"`,
            `"${currency ?? "N/A"}"`,
            `"${default_language ?? "N/A"}"`,
            `"${client?.clientDetails?.address ?? "N/A"}"`,
            `"${client?.clientDetails?.country ?? "N/A"}"`,
            `"${client?.clientDetails?.state ?? "N/A"}"`,
            `"${client?.clientDetails?.city ?? "N/A"}"`,
            `"${client?.clientDetails?.zip_code ?? "N/A"}"`,
            `"${client?.clientDetails?.email ?? "N/A"}"`,
            `"${new Date(client?.clientDetails?.created_at).toDateString() ?? "N/A"}"`,
          ].join(",") // Join all values into a single CSV row
        }),
      ].join("\n") // Join rows with newlines

      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" })
      saveAs(blob, "clients.csv")
    } catch (error) {
      console.log(error)
      openToast("An unexpected error occurred. Please try again.", "error")
    } finally {
      setIsDownloading(false)
    }
  }

  const exportPDF = async () => {
    setIsDownloading(true)
    try {
      const doc = new jsPDF()

      // Define table headers
      const headers = [
        [
          "Name",
          "Company",
          "Primary Contact",
          "Primary Email",
          "Phone",
          "Groups",
          "Currency",
          "Default Language",
          "Address",
          "Country",
          "State",
          "City",
          "Zip Code",
          "Date Created",
        ],
      ]

      const d = await fetchData()

      // Map projectDetails into rows
      const rows = d.map((client) => {
        const groups = client?.clientDetails?.groups?.join(";")
        const currency = client?.clientDetails?.currency?.join(";")
        const default_language = client?.clientDetails?.default_language?.join(";")

        return [
          client?.name ?? "N/A",
          client?.clientDetails?.company || "N/A", // Handle undefined `customer` gracefully
          client?.phone ?? "N/A",
          client?.email ?? "N/A",
          groups ?? "N/A",
          currency ?? "N/A",
          default_language ?? "N/A",
          client?.clientDetails?.address ?? "N/A",
          client?.clientDetails?.country ?? "N/A",
          client?.clientDetails?.state ?? "N/A",
          client?.clientDetails?.city ?? "N/A",
          client?.clientDetails?.zip_code ?? "N/A",
          client?.clientDetails?.email ?? "N/A",
          new Date(client?.clientDetails?.created_at).toDateString() ?? "N/A",
        ]
      })

      // Add title
      doc.setFontSize(16)
      doc.text("Client Details", 14, 10)

      // Add the table
      doc.autoTable({
        head: headers,
        body: rows,
        startY: 20, // Start below the title
        styles: {
          fontSize: 8, // Adjust font size for table
        },
        headStyles: {
          fillColor: [22, 160, 133], // Light green header background
          textColor: [255, 255, 255], // White header text
        },
      })

      // Save the PDF
      doc.save("ProjectDetails.pdf")
    } catch (error) {
      openToast("An unexpected error occurred. Please try again.", "error")
    } finally {
      setIsDownloading(false)
    }
  }

  const printContent = async () => {
    setIsDownloading(true)
    try {
      const d = await fetchData()

      const printContent = `
    <html>
      <head>
        <style>
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
          }
          table, th, td {
            border: 1px solid #ccc;
          }
          th, td {
            padding: 10px;
            text-align: left;
          }
          th {
            background-color: #f4f4f4;
          }
          h1 {
            text-align: center;
          }
        </style>
      </head>
      <body>
        <h1>Project Details</h1>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Company</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Address</th>
              <th>Country</th>
              <th>State</th>
              <th>City</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            ${d
              .map((client) => {
                const members = client?.staffId?.map((item) => item?.User?.name).join(", ")
                const tags = client?.tags?.join(", ")
                return `
                <tr>
                  <td>${client?.name || "N/A"}</td>
                  <td>${client?.clientDetails?.company || "N/A"}</td>
                  <td>${client?.email || "N/A"}</td>
                  <td>${client?.phone || "N/A"}</td>
                  <td>${client?.clientDetails?.address || "N/A"}</td>
                  <td>${client?.clientDetails?.country || "N/A"}</td>
                  <td>${client?.clientDetails?.state || "N/A"}</td>
                  <td>${client?.clientDetails?.city || "N/A"}</td>
                  <td>${new Date(client?.clientDetails?.created_at).toDateString() || "N/A"}</td>
                </tr>
              `
              })
              .join("")}
          </tbody>
        </table>
      </body>
    </html>
  `

      // Open a new window and trigger print
      const newWindow = window.open("", "_blank")
      newWindow.document.write(printContent)
      newWindow.document.close()
      newWindow.focus()
      newWindow.print()
      newWindow.close()
    } catch (error) {
      openToast("An unexpected error occurred. Please try again.", "error")
    } finally {
      setIsDownloading(false)
    }
  }

  const handleSearchCompany = async () => {
    const queryParams = new URLSearchParams({
      company: companyName,
    }).toString()
    setIsLoading(true)
    try {
      const response = await fetch(`${baseUrl}client/search?${queryParams}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })
      const result = await response.json()
      console.log(result.data)
      if (response.status === 200) {
        setClientDetail(result.data)
      } else {
        console.log("data is not filtered")
        openToast(result.message)
      }
    } catch (error) {
      console.error("Error searching staff:", error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (companyName === "") {
      fetchDetail()
    } else {
      handleSearchCompany()
    }
  }, [companyName, currentPage])

  const [modalIsOpen2, setIsOpen2] = React.useState(false)

  const [currency, setCurrency] = useState([])
  const [defaultLanguages, setDefaultLanguages] = useState([
    "portuguese",
    "German",
    "indonesia",
    "catlan",
    "Spanish",
    "Turkish",
    "Slovak",
    "Vitnamese",
    "Swedish",
    "Portguese_br",
    "ukrainian",
    "polish",
  ])
  const [language, setLanguage] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const groups = ["ASTROPITAH SMM PROJECT", "digital", "HONEY TOUR & TRAVELS", "vevge", "webs"]
  const [selectedGroups, setSelectedGroups] = useState([])
  const toggleGroupSelection = (group) => {
    setSelectedGroups((prevSelected) =>
      prevSelected.includes(group) ? prevSelected.filter((g) => g !== group) : [...prevSelected, group],
    )
  }
  const handleGroupSelection = (selectAll) => {
    if (selectAll) {
      setSelectedGroups(groups) //select all group
      setSelectAll(true)
    } else {
      setSelectedGroups([]) //deselect all group
      setSelectAll(false)
    }
  }
  const [selectedClient, setSelectedClient] = useState(null)

  // function to toggle the accordian
  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  const [company, setCompany] = useState(selectedClient?.clientDetails?.company)
  const [vatNumber, setVatNumber] = useState(selectedClient?.clientDetails?.vat_number)
  const [phone, setPhone] = useState(selectedClient?.phone)
  const [website, setWebsite] = useState(selectedClient?.clientDetails?.website)
  const [address, setAddress] = useState(selectedClient?.clientDetails?.address)
  const [city, setCity] = useState(selectedClient?.clientDetails?.city)
  const [state, setState] = useState(selectedClient?.clientDetails?.state)
  const [zipCode, setZipCode] = useState(selectedClient?.clientDetails?.zip_code)
  const [country, setCountry] = useState(selectedClient?.clientDetails?.country)
  const [clientGroup, setClientGroup] = useState([])
  const [email, setEmail] = useState(selectedClient?.email)

  const [deleteClient, setDeleteClient] = useState()
  const updateData = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const result = await fetch(baseUrl + "client/" + selectedClient.id, {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          company: company,
          vat_number: vatNumber,
          phone: phone,
          name: name,
          website: website,
          groups: selectedGroups,
          currency: currency,
          default_language: language,
          address: address,
          country: country,
          state: state,
          city: city,
          zip_code: zipCode,
          email: email,
        }),
      })
      const res = await result.json()
      if (result.status == 200) {
        fetchDetail()
        setOpenClientsEditModal(false)
        openToast(res.message)
      } else openToast(res.message)
    } catch (error) {
      console.log("error", error)
    } finally {
      setLoading(false)
    }
  }

  async function deleteData(id) {
    setLoading(true)
    try {
      const result = await fetch(baseUrl + "client/" + id, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })

      const res = await result.json()
      if (result.status === 200) {
        openToast("Client deleted successfully", "success")
        fetchDetail()
        setOpen8(false) // Close the modal
      } else {
        openToast(res.message, "error")
      }
    } catch (error) {
      console.error("Error deleting client:", error)
      openToast("An error occurred while deleting the client", "error")
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    setTimeout(() => setIsLoading(false), 3000)
  }, [])

  const [open, setOpen] = useState(false)

  const onOpenModal = () => setOpen(true)
  const onCloseModal = () => setOpen(false)

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1)
  }
  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1)
  }

  useEffect(() => {
    console.log(companyName)
    if (companyName == "") {
      fetchDetail()
    } else {
      handleSearchCompany()
    }
  }, [companyName])

  async function changeClientStatus(id, status) {
    if (!id) {
      openToast("Please provide a valid id ", "error")
      return
    }
    console.log(status)
    const result = await fetch(baseUrl + `client/${id}`, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
      body: JSON.stringify({
        status,
      }),
    })
    if (result.status == 200) {
      openToast("Status Changed Successfully", "success")
      fetchClientDetail()
    } else {
      openToast("An Error Occured", "error")
    }
  }

  const [massDelete, setMassDelete] = useState(false)
  const [selectedClients, setSelectedClients] = useState([])

  const handleMassDelete = () => {
    setMassDelete(!massDelete)
    if (!massDelete) {
      const allClients = clientDetail.map((client) => ({
        value: client.id,
        label: client.name,
      }))
      setSelectedClients(allClients)
    } else {
      setSelectedClients([])
    }
  }

  const handleSelectChangeBulk = (selectedOptions) => {
    setSelectedClients(selectedOptions || [])
  }

  const deleteClientsBulk = async () => {
    try {
      setIsLoading(true)
      const response = await fetch(`${baseUrl}client/bulk`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          clientIds: selectedClients.map(({ value }) => value),
        }),
      })

      if (response.ok) {
        const result = await response.json()
        openToast("Clients deleted successfully")
        fetchDetail()
        onCloseModal()
        return result
      }
    } catch (error) {
      console.error("Failed to delete clients:", error)
      openToast("Failed to delete clients", "error")
    } finally {
      setIsLoading(false)
    }
  }

  if (loadingClient && !clientDetail) {
    return <ClientSkeleton />
  }

  return (
    <div className="top-[95px] right-[5px] w-full">
      <ClientsEditModal
        open={openClientsEditModal}
        setOpen={setOpenClientsEditModal}
        setCompany={setCompany}
        setVatNumber={setVatNumber}
        setPhone={setPhone}
        setWebsite={setWebsite}
        setAddress={setAddress}
        setCity={setCity}
        setState={setState}
        setZipCode={setZipCode}
        setCountry={setCountry}
        setSelectedGroups={setSelectedGroups}
        setCurrency={setCurrency}
        setLanguage={setLanguage}
        selectedClient={selectedClient}
        fetchDetail={fetchDetail}
        setSelectedClient={setSelectedClient}
        company={company}
        vatNumber={vatNumber}
        phone={phone}
        website={website}
        address={address}
        city={city}
        state={state}
        zipCode={zipCode}
        country={country}
        selectedGroups={selectedGroups}
        currency={currency}
        language={language}
        name={name}
        setName={setName}
        email={email}
        setEmail={setEmail}
        groups={groups}
        defaultLanguages={defaultLanguages}
        setClientGroup={setClientGroup}
        updateData={updateData}
        loading={loading}
      />
      <div className="bg-[#fff] px-4 py-6">
        <div className="flex items-center gap-[10px] mb-[14px] import-customers">
          <Link
            to="/addnewclient
            "
            className="flex justify-center items-center gap-[3px] allcrm-btn font-medium text-center client-add focus:outline-none newcustomers"
          >
            <AddIcon className="newadd" /> New Clients
          </Link>

          {/* <Link
            to="/contact-information"
            className="bg-[#f4f2f2] dark:hover:bg-blue-700 dark:bg-blue-600 p-[8px] rounded-lg dark:focus:ring-blue-800 font-medium text-[#000] text-[14px] text-center client-add focus:outline-none"
          >
            <PersonIcon className="mr-[5px] newadd" />
            Contacts
          </Link> */}
        </div>

        <div className="border-[#dbdbdb] shadow-cs p-[20px] border rounded-lg">
          <h2 className="flex items-center gap-[6px] mb-[10px] font-medium">
            {" "}
            <LibraryBooksIcon />
            Clients
          </h2>

          <div className="flex sm:flex-row flex-col justify-between items-center gap-2 mb-3">
            <div className="flex sm:flex-row flex-col flex-wrap items-center gap-2 w-full">
              <select
                onChange={handleSelectChange}
                className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md w-full sm:w-[60px] text-[14px] focus:outline-none"
              >
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="120">120</option>
              </select>
              <select
                onChange={(e) => setExportFormat(e.target.value)}
                className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md w-full sm:w-[67px] text-[14px] focus:outline-none"
              >
                <option value="CSV">CSV</option>
                <option value="PDF">PDF</option>
                <option value="Print">Print</option>
              </select>

              <button
                onClick={handleExport}
                className="bg-[#27004a] p-[7px] rounded-md w-full sm:w-[123px] text-[14px] text-white cursor-pointer"
              >
                {isDownloading ? "Exporting..." : "Export File"}
              </button>
              <button
                className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-lg w-full sm:w-[123px] text-[14px]"
                onClick={onOpenModal}
              >
                Bulk Action <CachedIcon className="newsidebar-icon" />{" "}
              </button>
            </div>
            <div className="relative flex flex-wrap justify-end items-center gap-2 w-full">
              <input
                type="text"
                placeholder="Search"
                onChange={(e) => setCompanyName(e.target.value)}
                className="border-1 p-[10px] pr-7 border rounded-3xl w-[100%] md:w-[200px] h-[38px] text-[#000] text-[15px] ] focus:outline-none"
              />
              <SearchIcon className="right-[10px] absolute search-icon font-thin text-[#000] text-[#dddddd; ]" />{" "}
            </div>
          </div>

          <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-full overflow-x-auto sid">
            <table className="border-[#dcdbdb] border-collapse border rounded-lg w-full overflow-hidden table-auto">
              {/* Header with Toggle */}
              <thead className="border-gray-300 shadow-md border cursor-pointer" onClick={toggleAccordion}>
                <tr>
                  <th className="flex justify-center items-center p-3 border-r font-medium text-center text-xs whitespace-nowrap">
                    <IoMdArrowDropright
                      className={`text-[20px] transition-transform duration-200 ${
                        isOpen ? "rotate-90 text-[black]" : "rotate-0"
                      }`}
                    />
                  </th>
                  <th className="p-3 border-r font-medium text-center text-xs whitespace-nowrap">#</th>
                  <th className="p-3 border-r font-medium text-center text-xs whitespace-nowrap">Name</th>
                  <th className="p-3 border-r font-medium text-center text-xs whitespace-nowrap">Company</th>
                  <th className="p-3 border-r font-medium text-center text-xs whitespace-nowrap">Primary Contact</th>
                  <th className="p-3 border-r font-medium text-center text-xs whitespace-nowrap">Primary Email</th>
                  <th className="p-3 border-r font-medium text-center text-xs whitespace-nowrap">Phone</th>
                  <th className="p-3 border-r font-medium text-center text-xs whitespace-nowrap">Active</th>
                  <th className="p-3 border-r font-medium text-center text-xs whitespace-nowrap">Groups</th>
                  <th className="p-3 border-r font-medium text-center text-xs whitespace-nowrap">Date Created</th>
                  <th className="p-3 font-medium text-center text-xs">Action</th>
                </tr>
              </thead>

              <tbody className={`transition-body ${isOpen ? "open" : ""}`}>
                {loadingClient && !clientDetail && (
                  <tr className="h-[100px]">
                    <td colSpan="11" className="py-4 font-semibold text-center text-gray-600 text-xl">
                      <ClipLoader color="#27004a" size={50} />
                    </td>
                  </tr>
                )}

                {!loadingClient &&
                  clientDetail &&
                  clientDetail?.map((item, index) => (
                    <tr key={item?.id} className="border-gray-300 border-b">
                      <td className="border-[#dbdbdb] p-2 border-r text-center">
                        <input type="checkbox" className="h-4 text-xs" />
                      </td>
                      <td className="border-[#dbdbdb] p-2 border-r text-center text-xs whitespace-nowrap">
                        {index + 1}
                      </td>
                      <td className="border-[#dbdbdb] p-2 border-r text-center text-xs whitespace-nowrap">
                        {item?.name ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] p-2 border-r text-center text-xs whitespace-nowrap">
                        {item?.clientDetails?.company}
                      </td>
                      <td className="border-[#dbdbdb] p-2 border-r text-center text-xs whitespace-nowrap">
                        {item?.mobile}
                      </td>
                      <td className="border-[#dbdbdb] p-2 border-r text-center text-xs whitespace-nowrap">
                        {item?.email}
                      </td>
                      <td className="border-[#dbdbdb] p-2 border-r text-center text-xs whitespace-nowrap">
                        {item?.mobile}
                      </td>
                      <td className="border-[#dbdbdb] p-[10px] border-r font-medium text-[11px] whitespace-nowrap">
                        <div className="flex justify-center items-center gap-[6px]">
                          {(() => {
                            console.log(item?.clientDetails?.status)
                          })()}
                          <div
                            className={`${
                              item?.clientDetails?.status === true ? "bg-[#8a25b0]" : "bg-gray-300"
                            } relative inline-block w-12 h-6 rounded-full transition-colors duration-300 ease-in-out cursor-pointer`}
                            onClick={() => {
                              changeClientStatus(item?.clientDetails?.id, item?.clientDetails?.status)
                            }}
                          >
                            <span
                              className={`${
                                item?.clientDetails?.status ? "translate-x-6" : "translate-x-0"
                              } inline-block w-6 h-6 bg-[#f3ecec] rounded-full transform transition-transform duration-300 ease-in-out`}
                            />
                          </div>
                        </div>
                      </td>
                      <td className="border-[#dbdbdb] p-2 border-r text-center text-xs whitespace-nowrap">
                        {item?.clientDetails?.groups?.map((group) => group).join(", ")}
                      </td>
                      <td className="border-[#dbdbdb] p-2 border-r text-center text-xs whitespace-nowrap">
                        {new Date(item?.clientDetails?.created_at).toDateString()}
                      </td>
                      <td className="flex justify-center gap-2 p-2">
                        <BorderColorIcon
                          className="text-[#27004a] cursor-pointer"
                          onClick={() => {
                            setSelectedClient(item)
                            setOpenClientsEditModal(true)
                          }}
                        />
                        <div>
                          <button
                            onClick={() => {
                              setDeleteClient(item.id)
                              onOpenModal8()
                            }}
                          >
                            <DeleteIcon className="text-red-500 cursor-pointer" />
                          </button>
                          <Modal open={open8} onClose={onCloseModal8} center>
                            <div className="flex justify-center items-center h-[120px]">
                              <h2 className="font-medium text-[#27004a] text-[18px] text-center">
                                Are you sure want to delete this
                              </h2>
                            </div>
                            <div className="flex justify-around items-center">
                              <button
                                className={`allcrm-btn ${loading ? "opacity-40" : ""}`}
                                onClick={() => {
                                  deleteData(deleteClient)
                                }}
                              >
                                {loading ? "Confirming" : "Yes, Confirm"}
                              </button>
                              <button className="allcrm-btn" onClick={() => setOpen8(false)}>
                                No, Cancel
                              </button>
                            </div>
                          </Modal>
                        </div>
                      </td>
                    </tr>
                  ))}

                {!loadingClient && clientDetail && clientDetail?.length === 0 && (
                  <tr>
                    <td colSpan="11" className="py-4 font-medium text-center text-gray-600 text-md">
                      No Client Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[14px] pb-[0] w-[100%]">
            <p className="text-[#a5a1a1] text-[14px]">Total Records : {totalRecord}</p>
            <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
              <button
                onClick={handlePrevious}
                disabled={currentPage === 1}
                className={`pt-2 pb-[8px] text-[12px] ${currentPage == 1 ? "opacity-40" : ""}`}
              >
                Previous
              </button>
              <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">
                {/* {`Page ${currentPage} of ${totalPages}`} */}
                {currentPage}
              </span>
              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className={`pt-2 pb-[8px] text-[12px] ${currentPage === totalPages ? "opacity-40" : ""}`}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bulk action modal */}
      <Modal open={open} onClose={onCloseModal} center>
        <div className="border-[#dbdbdb] pb-[20px] border-b">
          <h2>Bulk Actions</h2>
        </div>
        <div className="flex items-center gap-[8px] mt-[32px] mb-[30px]">
          <input type="checkbox" checked={massDelete} onChange={handleMassDelete} />
          <p className="text-[14px]">Mass Delete</p>
        </div>
        <div className="w-[100%]">
          <Select
            isMulti
            options={clientDetail.map((client) => ({
              value: client.id,
              label: client.name,
            }))}
            onChange={handleSelectChangeBulk}
            value={selectedClients}
            className="basic-multi-select"
            classNamePrefix="select"
            styles={customStyles}
          />
        </div>
        {selectedClients.length === 0 && (
          <p className="mt-[10px] text-[14px] text-[red]">
            If you do not select any clients, all clients will be deleted.
          </p>
        )}
        <div className="flex justify-end gap-[10px] mt-[24px] pr-[10px] pb-3">
          <button className="second-btn" onClick={deleteClientsBulk} disabled={isLoading}>
            {isLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </Modal>
      {/* Bulk action modal end */}
    </div>
  )
}

const ClientSkeleton = () => {
  return (
    <div className="bg-white shadow-sm mt-5 px-6 py-8 rounded-lg w-full">
      {/* Top Controls */}
      <div className="flex items-center gap-2 mb-4">
        <Skeleton width={150} height={38} className="rounded-lg" />
      </div>

      <div className="shadow-sm p-5 border rounded-lg">
        {/* Title */}
        <div className="mb-4">
          <Skeleton width={120} height={24} />
        </div>

        {/* Action Controls */}
        <div className="flex flex-wrap justify-between items-center gap-2 mb-3">
          <div className="flex flex-wrap items-center gap-2">
            <Skeleton width={60} height={38} className="rounded-md" />
            <Skeleton width={67} height={38} className="rounded-md" />
            <Skeleton width={123} height={38} className="rounded-md" />
            <Skeleton width={123} height={38} className="rounded-md" />
          </div>
          <div className="relative">
            <Skeleton width={200} height={38} className="rounded-full" />
          </div>
        </div>

        {/* Table */}
        <div className="border rounded-lg overflow-x-auto">
          <table className="border-collapse w-full">
            <thead>
              <tr className="bg-gray-50 border-b">
                {[30, 30, 120, 120, 120, 150, 100, 80, 120, 120, 80].map((width, i) => (
                  <th key={i} className="p-3 border-r text-left">
                    <Skeleton width={width} height={16} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5].map((row) => (
                <tr key={row} className="border-b">
                  <td className="p-3 border-r">
                    <Skeleton width={16} height={16} />
                  </td>
                  <td className="p-3 border-r">
                    <Skeleton width={20} height={16} />
                  </td>
                  <td className="p-3 border-r">
                    <Skeleton width={100} height={16} />
                  </td>
                  <td className="p-3 border-r">
                    <Skeleton width={100} height={16} />
                  </td>
                  <td className="p-3 border-r">
                    <Skeleton width={100} height={16} />
                  </td>
                  <td className="p-3 border-r">
                    <Skeleton width={130} height={16} />
                  </td>
                  <td className="p-3 border-r">
                    <Skeleton width={80} height={16} />
                  </td>
                  <td className="p-3 border-r">
                    <Skeleton width={50} height={24} className="rounded-full" />
                  </td>
                  <td className="p-3 border-r">
                    <Skeleton width={100} height={16} />
                  </td>
                  <td className="p-3 border-r">
                    <Skeleton width={100} height={16} />
                  </td>
                  <td className="p-3">
                    <div className="flex justify-center gap-2">
                      <Skeleton width={20} height={20} />
                      <Skeleton width={20} height={20} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-between items-center mt-4 px-2">
          <Skeleton width={120} height={20} />
          <div className="flex items-center gap-2">
            <Skeleton width={80} height={32} className="rounded-md" />
            <Skeleton width={40} height={32} className="rounded-md" />
            <Skeleton width={80} height={32} className="rounded-md" />
          </div>
        </div>
      </div>
    </div>
  )
}
export default Clients

